import { Injector } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SfSelectData, SfSelectFormField } from 'ngx-smart-form';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';
import { Subscription, of, startWith, switchMap } from 'rxjs';
import { CmsService } from '../../_core/services/cms.service';

export class ProvinciaField<T> extends SfSelectFormField<T> {
  subscription?: Subscription;
  constructor(
    { formControlName, label, required, parent }: IFormField<T> & SfSelectData,
    private inj: Injector,
    private defaultValue?: string
  ) {
    super({ formControlName, label, required, parent, disabled: true });
  }

  override setControlRef(ctrlRef: AbstractControl<any, any> | null): void {
    super.setControlRef(ctrlRef);
    let parentCtrl = ctrlRef?.parent?.get(this.parent || '');
    this.subscription = (parentCtrl?.valueChanges || of(this.defaultValue))
      .pipe(
        startWith(parentCtrl?.value || this.defaultValue),
        switchMap((val) =>
          val === 'I' ? this.inj.get(CmsService).getCounties() : of([])
        )
      )
      .subscribe((res) => {
        this.options = res;
        if (res?.length) {
          if (!this.controlRef?.parent?.disabled) {
            this.controlRef?.enable();
          }
          this.controlRef?.setValue(this.controlRef?.value);
        } else {
          if (!this.controlRef?.parent?.disabled) {
            this.controlRef?.setValue(null);
          }
          this.controlRef?.disable();
        }
      });
  }
}
